import { render, staticRenderFns } from "./MainWrap.vue?vue&type=template&id=7050bdfc&scoped=true"
import script from "./MainWrap.vue?vue&type=script&lang=js"
export * from "./MainWrap.vue?vue&type=script&lang=js"
import style0 from "./MainWrap.scss?vue&type=style&index=0&id=7050bdfc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7050bdfc",
  null
  
)

export default component.exports